var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.71734C0.5 0.975985 1.01864 0.375 1.65842 0.375H22.3416C22.9814 0.375 23.5 0.975985 23.5 1.71734C23.5 2.45869 22.9814 3.05967 22.3416 3.05967H1.65842C1.01864 3.05967 0.5 2.45869 0.5 1.71734Z",
    fill: "#00a000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 9.00045C0.5 8.2591 1.01864 7.65811 1.65842 7.65811H14.6539C15.2937 7.65811 15.8123 8.2591 15.8123 9.00045C15.8123 9.7418 15.2937 10.3428 14.6539 10.3428H1.65842C1.01864 10.3428 0.5 9.7418 0.5 9.00045Z",
    fill: "#00a000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65842 14.9403C1.01864 14.9403 0.5 15.5413 0.5 16.2827C0.5 17.024 1.01864 17.625 1.65842 17.625H6.9662C7.60597 17.625 8.12462 17.024 8.12462 16.2827C8.12462 15.5413 7.60598 14.9403 6.9662 14.9403H1.65842Z",
    fill: "#00a000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.60b798fcd90358dec7a8bf9d560ac8c7.svg";
export { ForwardRef as ReactComponent };